import { Box, Button, Grid2, useTheme } from "@mui/material";
import FormTitle from "../../../../../views/components/common/form/FormTitle";
import FormSmallTextField from "../../../../../views/components/common/form/FormTextField";
import { useState } from "react";
import { VendorPOC } from "../../../../../models/Vendors/VendorPOC";
import { useStores } from "../../../use-stores";
import { useNotification } from "../../../../../utils/NotificationsContext";

export const AddPoc = () => {
  const theme = useTheme();
  const { vendorStore } = useStores();
  const [poc, setPoc] = useState<VendorPOC>({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
  });
  const { showError, showSuccess } = useNotification();

  const updatePocDetails = (id: string, value: string) => {
    setPoc((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };


  const savePoc = () => {
    if (poc.phone!?.trim().length > 10) {
      showError("Error", "Phone number length should be 10");
      return;
    }

    if (
      poc.first_name?.trim() !== "" &&
      poc.last_name?.trim() !== "" &&
      poc.phone?.trim() !== ""
    ) {
      vendorStore.addPoc(poc);
      setPoc({ first_name: "", last_name: "", email: "", phone: "" });
    } else {
      showError("Error", "Please fill all the mandatory fields (First Name, Last Name, Phone)");
    }
  };

  return (
    <Box
      sx={{
        p: 2.5,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: "8px",
        backgroundColor: theme.palette.grey[50],
        mt: 2,
      }}
    >
      <FormTitle title="Add New POC" marginBottom={0} />
      <Grid2 container spacing={2} sx={{ mt: 1 }}>
        <Grid2 size={{ xs: 12, sm: 6 }}>
          <FormTitle title="First Name *" fontSize="14px" marginBottom={0} />
          <FormSmallTextField
            id="first_name"
            label="Enter first name"
            required
            variant="outlined"
            color="secondary"
            type="name"
            fontSize="14px"
            onChange={(id, value) => updatePocDetails(id!, value!)}
            value={poc.first_name || ""}
            sx={{ mb: 0 }}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 6 }}>
          <FormTitle title="Last Name *" fontSize="14px" marginBottom={0} />
          <FormSmallTextField
            id="last_name"
            label="Enter last name"
            required
            variant="outlined"
            color="secondary"
            type="name"
            fontSize="14px"
            onChange={(id, value) => updatePocDetails(id!, value!)}
            value={poc.last_name || ""}
            sx={{ mb: 0 }}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 6 }}>
          <FormTitle title="Email" fontSize="14px" marginBottom={0} />
          <FormSmallTextField
            id="email"
            label="Enter email"
            variant="outlined"
            color="secondary"
            type="email"
            fontSize="14px"
            onChange={(id, value) => updatePocDetails(id!, value!)}
            value={poc.email || ""}
            sx={{ mb: 0 }}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 6 }}>
          <FormTitle title="Phone Number *" fontSize="14px" marginBottom={0} />
          <FormSmallTextField
            id="phone"
            label="Enter phone number"
            required
            variant="outlined"
            color="secondary"
            type="number"
            fontSize="14px"
            onChange={(id, value) => updatePocDetails(id!, value!)}
            value={poc.phone || ""}
            sx={{ mb: 0 }}
          />
        </Grid2>
      </Grid2>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 2,
          mt: 3,
        }}
      >
        {/* <Button
          variant="outlined"
          color="primary"
          onClick={() => addNewPoc()}
          sx={{
            borderRadius: "8px",
            textTransform: "none",
            px: 3,
          }}
        >
          Add POC
        </Button> */}
        <Button
          variant="contained"
          color="primary"
          onClick={() => savePoc()}
          sx={{
            borderRadius: "8px",
            textTransform: "none",
            px: 3,
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            "&:hover": {
              boxShadow: "0 6px 16px rgba(0, 0, 0, 0.2)",
            },
          }}
        >
          Add POC
        </Button>
      </Box>
    </Box>
  );
};
